<template>
  <div v-if="view === 'horizontal'">
    <v-table class="rounded-none" :header-class="headerClass">
      <template #header>
        <v-table-header>Ice Maker</v-table-header>
        <v-table-header>Remote Control</v-table-header>
        <v-table-header class="nowrap">Vends <span class="hidden lg:inline-flex">since Off</span></v-table-header>
        <v-table-header>Override</v-table-header>
      </template>

      <v-table-row
        v-for="(maker, index) in makers"
        :key="index"
        :class="{ 'text-gray-400': isDisabled(maker) && isRemoteControlDisabled(maker) }"
      >
        <v-table-col>Ice Maker {{ index+1 }}</v-table-col>
        <v-table-col>
          <ice-maker-button
            :disabled="isRemoteControlDisabled(maker)"
            v-model="state.form[`${maker}_running`]"
            @change="saveRunning(maker)"
            :is-loading="state.savingRunning[maker]"
          />
        </v-table-col>
        <v-table-col :class="{ 'text-gray-400': isDisabled(maker) }">
          {{ state.form[`${maker}_vends_since_off`] }}
        </v-table-col>
        <v-table-col class="w-5/12" :class="{ 'text-gray-400': isDisabled(maker) }">
          <div class="flex flex-row gap-x-2 items-center">
            <template v-if="!isDisabled(maker)">
              <toggle
                v-model="state.form.override[maker].enabled"
                @change="saveOverride()"
              />
              <span>Override if Vends exceed</span>
              <text-input
                @input="inputChanged"
                v-model="state.form.override[maker].override_at_vend_count"
                placeholder="Count"
                class="w-24"
              />
            </template>
            <template v-else>
              <span>Override if Vends exceed</span>
              <strong>{{ state.form.override[maker].enabled ? 'Enabled' : 'Disabled' }}</strong>
              <strong>{{ state.form.override[maker].override_at_vend_count }}</strong>
            </template>
          </div>
        </v-table-col>
      </v-table-row>

    </v-table>
  </div>
  <div v-else class="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4">

    <!-- Ice Maker 1 -->
    <div
      v-for="(maker, index) in makers"
      :key="index"
      :class="{ 'w-full md:w-1/2': true, 'text-gray-400': isDisabled(maker) && isRemoteControlDisabled(maker) }"
    >

      <div class="bg-white rounded-md overflow-hidden divide-y">
        <div class="px-4 py-1 bg-big-stone bg-opacity-90">
          <h4 class="font-semibold text-white">Ice Maker {{ index+1 }}</h4>
        </div>
        <div class="flex items-center">
          <div class="w-1/3 p-2">
            <h4 class="font-semibold">Remote Control</h4>
          </div>
          <div class="p-2">
            <ice-maker-button
              :disabled="isRemoteControlDisabled(maker)"
              v-model="state.form[`${maker}_running`]"
              @change="saveRunning(maker)"
              :is-loading="state.savingRunning[maker]"
            />
          </div>
        </div>
        <div class="flex items-center" :class="{ 'text-gray-400': isDisabled(maker) }">
          <div class="w-1/3 p-2">
            <h5 class="font-semibold">Vends Since Off</h5>
          </div>
          <div class="p-2 font-semibold">{{ state.form[`${maker}_vends_since_off`] }}</div>
        </div>
        <div class="flex items-center" :class="{ 'text-gray-400': isDisabled(maker) }">
          <div class="w-1/3 p-2">
            <h5 class="font-semibold">Override</h5>
          </div>
          <div class="p-2 flex items-center text-sm space-x-2">

            <template v-if="!isDisabled(maker)">
              <toggle
                v-model="state.form.override[maker].enabled"
                @change="saveOverride()"
              />
              <span class="leading-tight">Override if Vends exceed</span>
              <text-input
                @input="inputChanged"
                v-model="state.form.override[maker].override_at_vend_count"
                placeholder="Count"
                class="w-20 flex-shrink-0"
              />
            </template>
            <template v-else>
              <span class="leading-tight">Override if Vends exceed</span>
              <strong>{{ state.form.override[maker].enabled ? 'Enabled' : 'Disabled' }}</strong>
              <strong>{{ state.form.override[maker].override_at_vend_count }}</strong>
            </template>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { reactive, watch } from 'vue'
import http from '@/services/http.js'
import notification from '@/services/notifications.js'

import Toggle from '@/components/form/Toggle.vue'
import IceMakerButton from '@/components/schedules/IceMakerButton.vue'
import TextInput from '@/components/form/Text.vue'
import VTable from '@/components/Table.vue'
import VTableHeader from '@/components/TableHeader.vue'
import VTableRow from '@/components/TableRow.vue'
import VTableCol from '@/components/TableCol.vue'

export default {
  components: {
    TextInput,
    VTable,
    VTableHeader,
    VTableRow,
    VTableCol,
    Toggle,
    IceMakerButton,
  },

  props: {
    disabled: {
      default: false
    },
    makersState: {
      required: true
    },
    makers: {
      default: () => (['im_1', 'im_2']),
    },
    headerClass: {},
    view: {
      default: 'horizontal'
    },
  },

  setup(props) {
    const state = reactive({
      overrideTimeout: null,
      savingRunningDelay: null,
      form: props.makersState,
      savingRunning: {
        im_1: false,
        im_2: false,
      }
    })

    const saveOverride = async () => {
      try {
        // const values = {
        //   im_1: {
        //     override_at_vend_count: 100,
        //     enabled: true
        //   },
        //   im_2: {
        //     override_at_vend_count: 50,
        //     enabled: false
        //   }
        // }
        const values = state.form.override
        await http.post(`machine/${state.form.location_id}/schedule/override`, values)
        notification.success('Success', 'Override settings were changed')
      } catch (e) {
        if (e.response) {
          notification.error(e.response.data.Message)
        } else {
          notification.error('Something went wrong. Please, try again.')
        }
      }
      clearOverrideTimeout()
    }

    const saveRunning = async (maker) => {
      state.savingRunning[maker] = true
      const newState = state.form[`${maker}_running`]
      const actionId = state.form[`${maker}_action_id`]
      try {
        const values = {
          action: newState ? `start_${actionId}` : `stop_${actionId}`
        }
        await http.post(`machine/${state.form.location_id}/action`, values)
        notification.success('Success', 'Status was changed')
      } catch (e) {
        state.form[`${maker}_running`] = !newState
        if (e.response) {
          notification.error(e.response.data.Message)
        } else {
          notification.error('Something went wrong. Please, try again.')
        }
      }
      state.savingRunning[maker] = false
    }

    const isDisabled = (maker) => {
      return props.disabled || !state.form.can_edit || state.form[`${maker}_running`] === null
    }

    const isRemoteControlDisabled = (maker) => {
      return props.disabled || state.form[`${maker}_running`] === null
    }

    const clearOverrideTimeout = () => {
      clearTimeout(state.overrideTimeout)
      state.overrideTimeout = null
    }

    const inputChanged = () => {
      clearOverrideTimeout()
      state.overrideTimeout = setTimeout(saveOverride, 1000)
    }

    watch(
      () => props.makersState,
      () => {
        // skipping value override during override saving and running saving
        if (!state.overrideTimeout && Object.values(state.savingRunning).every(v => v === false)) {
          state.form = props.makersState
        }
      }
    )

    return {
      state,
      saveRunning,
      saveOverride,
      isDisabled,
      isRemoteControlDisabled,
      inputChanged,
    }
  }
}
</script>